import PropTypes from "prop-types";

// @mui material components
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

// Material Dashboard 3 PRO React components
import MDButton from "components/MDButton";

/**
 * MUI v5 confirmation dialog, replacing react-confirm-alert
 * (which renders outside the React tree and therefore has no access to the theme).
 */
export default function ConfirmDialog({
	open,
	title = "Confirmation",
	message,
	cancelText = "Annuler",
	confirmText = "Confirmer",
	confirmColor = "error",
	onCancel,
	onConfirm,
	children
}) {
	return (
		<Dialog open={!!open} onClose={onCancel} maxWidth="xs" fullWidth>
			<DialogTitle>{title}</DialogTitle>
			<DialogContent>
				{message && <DialogContentText>{message}</DialogContentText>}
				{/* Free content (e.g. inputs), which cannot be nested in DialogContentText */}
				{children}
			</DialogContent>
			<DialogActions>
				<MDButton variant="outlined" color="secondary" onClick={onCancel}>
					{cancelText}
				</MDButton>
				<MDButton variant="gradient" color={confirmColor} onClick={onConfirm}>
					{confirmText}
				</MDButton>
			</DialogActions>
		</Dialog>
	);
}

ConfirmDialog.propTypes = {
	open: PropTypes.bool,
	title: PropTypes.string,
	message: PropTypes.node,
	cancelText: PropTypes.string,
	confirmText: PropTypes.string,
	confirmColor: PropTypes.string,
	onCancel: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
	children: PropTypes.node
};
